import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { setMessage } from "./message"
import EventBus from "../../utils/EventBus"
import EMPLOYEEAPI from "../../Api/employee"
import CUSTOMERAPI from "../../Api/customer"

export const fetchCustomers = createAsyncThunk("customer/fetchCustomers", async (params, thunkAPI) => {
  try {
    const response = await CUSTOMERAPI.getCustomers(params)
     return response.data   
  } catch (error) {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue(message)
  }
})

export const fetchCustomerByid = createAsyncThunk("employee/fetchCustomerByid", async ({c_id}, thunkAPI) => {
  try {
    const response = await CUSTOMERAPI.getCustomerByid(c_id)
    console.log(response.data);
     return response.data   
     
  } catch (error) {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue(message)
  }
})

// export const fetchInactiveEmployees = createAsyncThunk("employee/fetchInactiveEmployees", async (params, thunkAPI) => {
//   try {
//     const response = await EMPLOYEEAPI.getInactiveEmployees(params)
//      return response.data   
//   } catch (error) {
//     if (error.response && (error.response.status === 401 || error.response.status === 403)) {
//       EventBus.dispatch("logout");
//     }
//     const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
//     thunkAPI.dispatch(setMessage(message));
//     return thunkAPI.rejectWithValue(message)
//   }
// })

export const createCustomer = createAsyncThunk("roles/createCustomer", async (formData, thunkAPI) => {
  try {
    const response = await CUSTOMERAPI.addCustomer(formData)
    const message=(response.message)

    thunkAPI.dispatch(setMessage(message))

    return response
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message));
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    return thunkAPI.rejectWithValue(message)
  }
})


export const updateCustomer = createAsyncThunk("roles/updateCustomer", async ({c_id, formData}, thunkAPI) => {
  try {
    const response = await CUSTOMERAPI.updateCustomer(c_id, formData)
    const message=(response.message)
    
    thunkAPI.dispatch(setMessage(message))

    return response
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message))
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    return thunkAPI.rejectWithValue(message)
  }
})

export const fetchCustomerAppByid = createAsyncThunk("employee/fetchCustomerAppByid", async ({id}, thunkAPI) => {
  try {
    const response = await CUSTOMERAPI.getCustomerById(id)
    console.log(response.data);
     return response.data   
     
  } catch (error) {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue(message)
  }
})

// Export Customer

// Customer as CSV
export const exportCustomerAsCsv = createAsyncThunk("customer/exportCustomerAsCsv", async (params, thunkAPI) => {
  try {
      const response = await CUSTOMERAPI.exportCustomerAsCsv(params);
      return response.data;
  } catch (error) {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          EventBus.dispatch("logout");
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
  }
});

// Customer as Excel
export const exportCustomerAsExcel = createAsyncThunk("customer/exportCustomerAsExcel", async (params, thunkAPI) => {
  try {
      const response = await CUSTOMERAPI.exportCustomerAsExcel(params);
      return response.data;
  } catch (error) {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          EventBus.dispatch("logout");
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
  }
});

// Import Customer
export const importCustomers = createAsyncThunk("customer/importCustomers", async (formData, thunkAPI) => {
  try { 
      const response = await CUSTOMERAPI.importCustomers(formData);
      console.log(response)
      return response.data;
  } catch (error) {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          EventBus.dispatch("logout");
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
  }
});




const customerSlice = createSlice({
  name: "customer",
  initialState: {
    customers: [],
    customerDetail: null,
    customerApp:null,
    totalPages: 0,
    totalCount: 0
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.customers = action.payload.data
        state.totalPages = action.payload.totalPages
        state.totalCount = action.payload.totalCount
      })
      .addCase(createCustomer.fulfilled, (state, action) => {
        state.customers.push(action.payload.data)
      })
      .addCase(updateCustomer.fulfilled, (state, action) => {
              const {
                arg: { c_id },
              } = action.meta;
              if (c_id) {
                state.customers = state.customers.map((item) =>
                  item._id === c_id ? action.payload.data : item
                );
              };
        })
      .addCase(fetchCustomerByid.fulfilled, (state, action) => {
        state.customerDetail = action.payload.data
      })
      // .addCase(fetchInactiveEmployees.fulfilled, (state, action) => {
      //   state.employees = action.payload.data
      // })

      .addCase(fetchCustomerAppByid.fulfilled, (state, action) => {
        state.customerApp = action.payload.data
      })
      // Customer as CSV
          .addCase(exportCustomerAsCsv.fulfilled, (state, action) => {
              console.log(action)
              state.customers = action.payload.data;
              state.totalPages = action.payload.totalPages;
          })
          // Lead as Customer
          .addCase(exportCustomerAsExcel.fulfilled, (state, action) => {
              console.log(action)
              state.customers = action.payload.data;
              // state.totalPages = action.payload.totalPages;
          })
          // Import Customer
          .addCase(importCustomers.fulfilled, (state, action) => {
              state.customers.push(action.payload.data); 
          })
  } 
})

const { reducer } = customerSlice
export default reducer
